(function ($) {
  $(function () {
    var win_width;
    function initActiveScrollSelector() {
      win_width = $(window).width();

      if ($('.why-veriverse').length > 0) {
        var activeSelector = $("section");
      } else {
        var activeSelector = $(".two-col-image .row-wrap");
      }

      var nav = $(".header"),
        nav_height = nav.outerHeight();
      var tab = $(".sticky-nav ul");

      if ($(".sticky-nav").length > 0) {
        var offset = $(".sticky-nav").offset().top - nav_height;
      }

      $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        activeSelector.each(function () {
          var id = $(this).attr("id");
          var top = $(this).offset().top - nav_height - 143,
            bottom = top + $(this).outerHeight();
          if (scroll >= top && scroll <= bottom) {
            tab.find("li.active").siblings("li.active").removeClass("active");
            tab.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
          }

          if ($('.why-veriverse').length > 0) {
            if (scroll > 5000) {
              tab.find("li.active").removeClass("active");
            }
          } else {
            if (scroll > 4027) {
              tab.find("li.active").removeClass("active");
            }
          }

        });

        var scroll1 = $(window).scrollTop();
        if (scroll1 > offset) {
          if (win_width > 767) {
            $(".sticky-nav").addClass("fixed");
            $(".sticky-nav").next().addClass("top-space");
          }
        } else {
          $(".sticky-nav").removeClass("fixed");
          $(".sticky-nav").next().removeClass("top-space");
          $(".sticky-nav li").removeClass("active");
        }
      });
    }
    $(document).ready(function () {
      $('.sticky-nav li a[href^="#"]').on("click", function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $("html, body").stop().animate({
          scrollTop: $target.offset().top - $(".header").height() - 90,
        }, 900, "swing",
          function () { }
        );
      });
      initActiveScrollSelector();
    });

    $(window).on("resize", function () {
      initActiveScrollSelector();
    });
  });
})(jQuery);
